module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABTUlEQVQ4T6WSsUvDUBCHvwtEXBzs5CBiBx1EXXXv4K7o4Caibo6VJq0U9KXo1lEQcRCc1F36Bwg6CQXBxQ5uFp215CQhhTS+iOCbjt/v7nt3753wzyPW+prOEeIDi4CDco/QwMhDNv8noKZrhFwAbiY5RNkikLO0PgioahHlCRjKmSykxzxH0u77gwBfT4Dt2FS6KDXgE4dDYCwpusTIuh3gaRthJjZDVmjIdRx7WkJoJeAXAinmAToIE4k5iZFOHNe1wBfdRH/HSCEPcIewkNy0TyAHcezrLtBMip4xMm0HVNTDwaQe8AboAasp7Rgje3ZAWUdwidoezfmFN1ymqMuHHRCpFd3E4dQKUDYI5Dx/D/qOpy2EUgZyi5GlLNi+ymUdx+UxNUrU8ixGXv8GiLKquoxy9WMnMgR7B/0kX5sowwSyk/Oo/A7Iq0rp3+LiXREdtFJ1AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fuwuxiang/fws_icon_location.png
// module id = WVex
// module chunks = 1